import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Administrator extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Administrator';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'administrator', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'administrator',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/administrators/' + this.id;
    }
}
